import useCertificateHelper from 'hooks/useCertificateHelper';
import { CertificateNestedProperty } from 'models/certificate.model';

import CompositionDetail from '../CompositionDetail';
import * as Styled from './CompositionRow.styles';

type Props<T extends string> = {
  composition?: CertificateNestedProperty<T>[];
  labels: T[];
};

function CompositionRow<T extends string>({ composition = [], labels }: Props<T>) {
  const { getLabel, getValueByLabel, defaultValue } = useCertificateHelper();

  return (
    <Styled.CompositionRow>
      {labels.map((label, index) => (
        <CompositionDetail
          label={getLabel(label)}
          value={getValueByLabel(label, composition) || defaultValue}
          key={`row_${index}`}
        />
      ))}
    </Styled.CompositionRow>
  );
}

export default CompositionRow;
